const BookingCancelCause = {
    CUSTOMER_REQUEST: "customer-request",
    OTHER: "other",
};

export default BookingCancelCause;
